export function About() {
    return (
      <div className="App">
        <header className="App-header">
          <p>
            Hi! I'm a software engineer currently based out of New York City. <br/>
            I work on infrastructure at <a href="https://www.datadoghq.com">Datadog</a> <br/>
            <br/>
            I'm best contacted via email at george.wu.1923@gmail.com.
          </p>
        </header>
      </div>
    );
  }